export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15229.1773706a.jpg";